<app-dialog [dataSelector]="dataSelector + '-container'">
  <app-dialog-header [dataSelector]="dataSelector + '-header'">
    Add Note
  </app-dialog-header>

  <div class="modal-content" [dataSelector]="dataSelector + '-content'">
    <p class="body-400 color-gray-300 mb-3" [dataSelector]="dataSelector + '-description'">
      Not Applicable Reason for "{{ data.requestItemName }}"
    </p>

    <div class="form-group" [dataSelector]="dataSelector + '-textarea-group'">
      <textarea
        #noteTextarea
        class="form-control form-textarea"
        placeholder="Type your note here..."
        rows="4"
        [formControl]="noteControl"
        [dataSelector]="dataSelector + '-textarea'"
      ></textarea>
      
      <div class="d-flex justify-content-between align-items-center mt-2">
        <div class="form-control small-300 color-gray-400">
          {{ characterCount }}/{{ MAX_CHARACTERS }} characters
        </div>
        
        @if (noteControl.errors?.['maxlength']) {
          <div class="text-danger small-300">
            Note exceeds maximum length
          </div>
        }
      </div>
    </div>
  </div>

  <app-dialog-footer [showCancel]="false" [dataSelector]="dataSelector + '-footer'">
    <div class="w-100 d-flex justify-content-between">
      <button
        andButton
        color="default"
        type="button"
        [dataSelector]="dataSelector + '-cancel-button'"
        (click)="onCancel()"
      >
        Cancel
      </button>

      <button
        andButton
        color="primary"
        type="button"
        [disabled]="!noteControl.valid"
        [dataSelector]="dataSelector + '-save-button'"
        (click)="onSave()"
      >
        Save & Close
      </button>
    </div>
  </app-dialog-footer>
</app-dialog>